import { useState, useEffect } from 'react';
import { formatDate } from '../../../lib/date';

const replaceUnderScoreToSpace = (str) => {
  return str.replace(/[_]/g, ' ');
};

const convertStringToCapitalized = (str) => {
  return replaceUnderScoreToSpace(
    str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
  );
};

const ListItem = ({ icon, children }) => {
  return (
    <li className='flex items-start gap-2'>
      <span>{icon}</span>
      <span className='flex items-center gap-1 flex-wrap'>{children}</span>
    </li>
  );
};

const About = ({ challenge }) => {
  const [averageDuration, setAverageDuration] = useState(0);

  useEffect(() => {
    const routines = challenge?.routines;
    if (Array.isArray(routines) && routines.length > 0) {
      const dailyDurations = [];

      routines.forEach((routine) => {
        if (routine.routine?.duration) {
          dailyDurations.push(routine.routine?.duration);
          return;
        }
        const cycle = routine.routine.cycle;
        const cycleRest = routine.routine.restTime;

        const groups = routine.routine.groups;
        const groupRest = groups.reduce((acc, cur) => {
          return acc + cur.exerciseSet?.restTime;
        }, 0);

        const sets = groups.reduce((acc, cur) => {
          return acc.concat(cur.exerciseSet?.sets);
        }, []);
        const setsDuration = sets.reduce((acc, cur) => {
          return acc + (cur.exerciseDetail.mode === 'TIME' ? cur.modeValue : 0);
        }, 0);

        dailyDurations.push(
          cycle * (setsDuration + groupRest) + (cycle - 1) * cycleRest
        );
      });

      setAverageDuration(
        dailyDurations.reduce((acc, cur) => acc + cur, 0) /
          dailyDurations.length
      );
    }
  }, [challenge]);

  return (
    <div className='space-y-2'>
      <h2 className='uppercase font-bold text-sm text-white'>
        about the challenge
      </h2>
      <ul className='list-none rounded-xl px-4 py-3 bg-tertiary/20 space-y-2'>
        {challenge?.places.length > 0 && (
          <ListItem icon='🏠'>
            {challenge.places.map((place, i) => (
              <div
                key={i}
                className='text-white text-xs bg-tertiary/60 rounded-full px-2 py-1'
              >
                {convertStringToCapitalized(place.place)}
              </div>
            ))}
          </ListItem>
        )}
        {challenge?.category === 'WORKOUT' && (
          <ListItem icon='🏋🏼'>
            {challenge?.equipments.length > 0 ? (
              challenge?.equipments.map((equip, i) => (
                <div
                  key={i}
                  className='text-white text-xs bg-tertiary/60 rounded-full px-2 py-1'
                >
                  {convertStringToCapitalized(equip.equipment)}
                </div>
              ))
            ) : (
              <div className='text-white text-xs bg-tertiary/60 rounded-full px-2 py-1'>
                Equipment optional
              </div>
            )}
          </ListItem>
        )}
        {challenge?.category === 'WORKOUT' && averageDuration > 0 && (
          <ListItem icon='⏱️'>
            <div className='text-white text-xs bg-tertiary/60 rounded-full px-2 py-1'>
              {Math.round(averageDuration / 60)} mins / day
            </div>
          </ListItem>
        )}
        <ListItem icon='🗓️'>
          <div className='text-white text-xs bg-tertiary/60 rounded-full px-2 py-1'>
            {challenge?.days} days
          </div>
          {challenge?.live && (
            <span className='text-xs opacity-40 text-white'>
              ({formatDate(new Date(challenge?.startDate))} -{' '}
              {formatDate(new Date(challenge?.endDate))})
            </span>
          )}
        </ListItem>
      </ul>
    </div>
  );
};

export default About;
